// src/pages/About.jsx
import React from "react";

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12 space-y-12">
      {/* Hero / Intro */}
      <section className="bg-white rounded-2xl shadow-soft border p-8">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-ink mb-3">
          Maynooth University Women &amp; Girls in STEM After-School Club
        </h1>
        <p className="text-ink/80 text-sm sm:text-base">
          The Computer Science Department at Maynooth University 
          is excited to continue our new after-school club for women and girls who are
          passionate about STEM (science, technology, engineering, and mathematics).
          This is a fantastic opportunity to meet new people, make friends, 
          and develop new skills, all while having fun!
        </p>
      </section>

      {/* What we do */}
      <section className="grid gap-8 lg:grid-cols-2">
        <div className="bg-white rounded-2xl shadow-soft border p-6">
          <h2 className="text-xl font-semibold text-ink mb-2">
            What happens in a typical session?
          </h2>
          <p className="text-ink/80 text-sm sm:text-base mb-3">
            Each week focuses on a different STEM theme or activity. Sessions
            might include:
          </p>
          <ul className="list-disc list-inside text-ink/80 text-sm sm:text-base space-y-1">
            <li>Coding projects using tools like Scratch and Python Turtle.</li>
            <li>Creative technology such as TurtleStitch, 3D printing and UI design.</li>
            <li>Electronics and problem-solving challenges.</li>
            <li>Exploring topics like DNA, cryptography and computational thinking.</li>
            <li>Multimedia activities, including video making, editing and Soundtrap.</li>
          </ul>
          <p className="text-ink/80 text-sm sm:text-base mt-3">
            Activities are designed to be hands-on and collaborative, with lots
            of space for questions and experimentation.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-soft border p-6">
          <h2 className="text-xl font-semibold text-ink mb-2">
            Who is the club for?
          </h2>
          <p className="text-ink/80 text-sm sm:text-base mb-3">
            The club is aimed at girls and young women who are curious about
            STEM, regardless of previous experience. This event is open to people who are 
            in 5th class (primary school) as well as secondary school and college
             students, and staff members. Children under the age of 13 need to be 
             accompanied by a parent or guardian. 
          </p>
          <p className="text-ink/80 text-sm sm:text-base">
            Volunteers include university students and staff who act as mentors,
            facilitators and role models. They support activities, answer
            questions and help create a friendly, inclusive atmosphere where
            everyone feels welcome to participate.
          </p>
        </div>
      </section>

      {/* How it runs / structure */}
      <section className="bg-white rounded-2xl shadow-soft border p-6">
        <h2 className="text-xl font-semibold text-ink mb-3">
          How the club is organised
        </h2>
        <div className="grid gap-6 md:grid-cols-3 text-sm sm:text-base text-ink/80">
          <div>
            <h3 className="font-semibold text-ink mb-1">Time &amp; location</h3>
            <p>
              Sessions typically run in the Eolas
              Building on the Maynooth University North Campus.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-ink mb-1">Format</h3>
            <p>
              Each week includes an activity with a short introduction,
              a guided hands-on task and time for questions, reflection and
              sharing work.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-ink mb-1">Support</h3>
            <p>
              Sessions are supported by volunteers who help with
              facilitation, mentoring and encouraging participants.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-white rounded-2xl shadow-soft border p-6">
        <h2 className="text-xl font-semibold text-ink mb-4">Testimonials</h2>
        <p className="text-ink/70 text-sm sm:text-base mb-6">
          Below are a few reflections from previous participants and volunteers
          about their experience with the Women &amp; Girls in STEM Club.
        </p>

        <div className="grid gap-6 md:grid-cols-3 text-sm">
          <Testimonial
            quote="Such an inspiring few weeks - you have successfully sparked serious interest in my 7 year old girl to pursue 'all things coding!"
            /*name="Sample Person"*/
          />
          <Testimonial
            quote="Amazing introduction to STEM for young girls!"
            /*name="Sample Person"*/
          /*/>
          <Testimonial
            quote="Sample testimony"
            name="Sample person"*/
          />
        </div>
      </section>

      {/* Closing note */}
      <section className="bg-white rounded-2xl shadow-soft border p-6">
        <h2 className="text-xl font-semibold text-ink mb-3">
          Maynooth University Women & Girls In STEM club Goal
        </h2>
        <p className="text-ink/80 text-sm sm:text-base">
          The club aims to build a supportive community where women and girls
          can explore STEM subjects, ask questions freely and see themselves as
          future scientists, technologists, engineers and mathematicians. By
          combining practical activities with mentoring and role models, we hope
          to make STEM feel welcoming, creative and open to everyone.
        </p>
      </section>
    </div>
  );
}

function Testimonial({ quote, name }) {
  return (
    <figure className="h-full flex flex-col justify-between rounded-2xl bg-ash/40 border px-4 py-3">
      <blockquote className="text-ink/80 text-sm italic">
        “{quote}”
      </blockquote>
      <figcaption className="mt-3 text-xs font-medium text-ink/70">
        {name}
      </figcaption>
    </figure>
  );
}
